/* eslint-disable max-len */
import headerActionsStyle from '../../material-dashboard-pro-react/assets/jss/material-dashboard-pro-react/components/headerActionsStyle';

import {
  defaultFont,
  primaryColor,
  secondaryColor,
} from '../../styles/style';

const style = (theme) => ({
  ...headerActionsStyle(theme),
  popper_responsive: {
    [theme.breakpoints.down('sm')]: {
      zIndex: '1640',
      position: 'static',
      float: 'none',
      width: 'auto',
      marginTop: '0',
      backgroundColor: 'transparent',
      border: '0',
      boxShadow: 'none',
      color: 'black',
    },
  },
  popper_close: {
    pointerEvents: 'none',
  },

  link__text: {
    zIndex: '4',
    ...defaultFont,
    fontSize: '14px',
    margin: '0!important',
  },
  button: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'flex-start',
      width: '100%',
      margin: '0 20px',
    },
  },

  dropdown: {
    maxWidth: '300px',
  },
  dropdown__header: {
    ...defaultFont,
    fontWeight: '400',
    fontSize: '13px',
    color: '#FFF',
    padding: '10px 20px',
  },
  dropdown__header_helpAndSupport: {
    textAlign: 'center',
    backgroundColor: secondaryColor,
  },
  dropdown__header_profile: {
    textAlign: 'center',
    backgroundColor: secondaryColor,
  },
  dropdown__header_accountSwitcher: {
  },
  dropdown__header_organizationSwitcher: {
  },
  dropdown__header_accountName: {
    width: '65%',
    marginRight: '10px',
  },
  dropdown__item: {
    ...defaultFont,
    'display': 'flex',
    'justifyContent': 'flex-start',
    'alignItems': 'center',
    'fontSize': '13px',
    'padding': '10px 20px',
    'borderRadius': '2px',
    'position': 'relative',
    'transition': 'all 150ms linear',
    'clear': 'both',
    'fontWeight': '400',
    'height': 'fit-content',
    'color': '#333',
    'whiteSpace': 'nowrap',
    '&:hover': {
      backgroundColor: primaryColor,
      color: '#FFFFFF',
    },
  },
  dropdown__item_email: {
    'backgroundColor': secondaryColor,
    'color': '#FFF',
    'display': 'inherit',
    'textAlign': 'center',
    '&:hover': {
      backgroundColor: secondaryColor,
      color: '#FFF',
    },
  },
  dropdown__item_header: {
    'backgroundColor': secondaryColor,
    'color': '#FFF',
    'display': 'inherit',
    'textAlign': 'center',
    '&:hover': {
      backgroundColor: secondaryColor,
      color: '#FFF',
    },
  },
  dropdownItem__icon: {
    marginRight: '5px',
    width: '25px',
    height: '25px',
  },
  dropdown__item_filterAccounts: {
    '&:hover': {
      backgroundColor: '#FFF',
    },
  },
  dropdown_item_loggedInAccount: {
    backgroundColor: secondaryColor,
    color: '#FFF',
    pointerEvents: 'none',
  },
  dropdownItem__accountName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginRight: '10px',
  },
  dropdown__item_filterOrganizations: {
    '&:hover': {
      backgroundColor: '#FFF',
    },
  },
  dropdown_item_currentOrganization: {
    backgroundColor: secondaryColor,
    color: '#FFF',
    pointerEvents: 'none',
  },
  dropdownItem__organizationName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginRight: '10px',
  },

  action__menuList: {
    padding: 0,
    maxHeight: '500px',
    overflowY: 'auto',
  },

  selectedOrgContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    fontSize: 14,
  },

  selectedOrgRed: {
    color: secondaryColor,
    fontWeight: 'bold',
  },

  clearOrgButton: {
    marginLeft: 6,
    marginRight: 6,
    width: 18,
    height: 18,
    borderRadius: '50%',
    backgroundColor: secondaryColor,
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 15,
    cursor: 'pointer',
    userSelect: 'none',
    transition: 'background-color 0.2s ease',
  },
});

export default style;
